import { signIn } from "../lib/api.js";

export function LoginPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-paper text-ink">
      <div className="w-full max-w-sm rounded-lg border border-black/10 bg-white p-8 text-center">
        <h1 className="mb-2 text-xl font-semibold">Jaypie Studio</h1>
        <p className="mb-6 text-sm text-ink/60">
          Sign in to reach your organization.
        </p>
        <button
          type="button"
          onClick={() => signIn("/")}
          className="w-full rounded bg-jay px-4 py-2 font-medium text-white hover:opacity-90"
        >
          Sign in
        </button>
      </div>
    </div>
  );
}
